
import React, { useState, useEffect } from 'react';
import {
    Layout, Row, Col, Button, Form, Input, Steps, Spin, Space, Modal, InputNumber, Alert, Radio, Checkbox, Select
} from 'antd';
import {
    getSymbolToken,
    getTotalSupply,
    getTokenName,
    getTokenDecimal,
    approveToken,
    getTokenAllowance,
    createStandardToken
} from '../../../../utils';
import standardTokenAbi from '../../../../../config/abi/standardTokenAbi.json';
import tokenInfoAbi from '../../../../../config/abi/tokenInfo.json';
import {
    STANDARD_TOKEN_BYTECODE
} from '../../../../../components/bytecodes/bytecodes';
import { useActiveWeb3React } from '../../../../../hooks';
import web3 from 'web3';
import { ethers } from 'ethers';

import { IdoLaunchpad } from '../../../../../config/api/idoLaunchpad';

import { getInformationByChain } from '../../../../../config/network/multichainAddresses';
import { dexExchanges } from '../../../../../config/network/dex';
import {
    INIT_LAUNCHPAD_FEE,
    INIT_LIQUIDITY_TOKEN_FEE_WALLET,
    INIT_TOKEN_FEE,
    INIT_TOKEN_FEE_WALLET,
    LAUNCHPAD_AMOUNT_RAISED_FEE,
    LIST_LAUNCHPAD_RAISED_FEE_ONLY,
    LIST_LAUNCHPAD_TOKEN_RAISED_FEE,
    LIST_LAUNCHPAD_RAISED_FEE,
    LIST_LAUNCHPAD_TOKEN_HLUP_FEE_OPTION_1,
    LIST_LAUNCHPAD_TOKEN_HLUP_FEE_OPTION_2
} from '../../../../../components/keyConfig';
import { currencies, getCurrencyAddress, getCurrencyDecimals } from '../../../../../config/network/config';
import { Store } from 'react-notifications-component';
import addNotify from '../../../../common/Notify/addNotify';
import { Loader } from '../../../../common/component';

const { Option } = Select;

const VerifyToken = (props) => {

    const { account, library, chainId } = useActiveWeb3React();

    const { form } = props;
    let storageTokenInfo = window.localStorage.getItem('tokenInfo');
    let storageTokenApproval = window.localStorage.getItem('tokenApproval');

    let tokenInfo;
    if (storageTokenInfo) {
        tokenInfo = JSON.parse(storageTokenInfo);
    }
    let tokenApproval;
    if (storageTokenApproval) {
        tokenApproval = JSON.parse(storageTokenApproval);
    }

    // const fundAddress = process.env.REACT_APP_FUND_ADDRESS;
    // const fundAmount = process.env.REACT_APP_FUND_AMOUNT;
    const provider = getInformationByChain(chainId, 'REACT_APP_RPC_URL');
    const deployLaunchpadAddress = getInformationByChain(chainId, 'REACT_APP_DEPLOY_LAUNCHPAD');
    const antiBotAddress = getInformationByChain(chainId, 'REACT_APP_ANTI_BOT');

    const [loadingFull, setLoadingFull] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingTokenInfo, setLoadingTokenInfo] = useState(false);
    const [tokenAddress, setTokenAddress] = useState(tokenInfo ? tokenInfo.token_address : '');
    const [tokenType, setTokenType] = useState('standard');
    const [cexList, setCexList] = useState([]);
    const [baseCurrencies, setBaseCurrencies] = useState([]);
    const [chainNetworkList, setChainNetworkList] = useState([]);

    let feeOptionDefault = JSON.stringify([INIT_LAUNCHPAD_FEE, LIST_LAUNCHPAD_RAISED_FEE_ONLY]);
    let listingOptionDefault = 1;

    let activeCurrencyPay = currencies[chainId]?.[0];

    if (tokenInfo && tokenInfo.fee_options) {
        feeOptionDefault = tokenInfo.fee_options;
    }
    if (tokenInfo && tokenInfo.listing_option) {
        listingOptionDefault = tokenInfo.listing_option;
    }

    let networkChain = 'BSC';
    if (chainNetworkList && chainId) {  
        let currentChain = chainNetworkList.filter((itemChain) => chainId === parseInt(itemChain.chainId));
        if (currentChain.length > 0) {
            networkChain = currentChain[0].symbol;
        }
    }

    const [feeList, setFeeList] = useState([]);

    const [currencyPay, setCurrencyPay] = useState(activeCurrencyPay);
    const [feeOptions, setFeeOptions] = useState(feeOptionDefault);
    const [listingOptions, setListingOptions] = useState(listingOptionDefault);
    const [errorCallSC, setErrorCallSC] = useState(false);
    const [isCreateTokenVisible, setIsCreateTokenVisible] = useState(false);

    //INIT_LAUNCHPAD_FEE
    const [createPoolFee, setCreatePoolFee] = useState([]);

    const [launchpadRaisedFeeOnly, setLaunchpadRaisedFeeOnly] = useState([]);

    // LIST_LAUNCHPAD_TOKEN_RAISED_FEE
    const [launchpadTokenRaisedFee, setLaunchpadTokenRaisedFee] = useState([]);

    //LAUNCHPAD_RAISED_FEE
    const [launchpadRaisedFee, setLaunchpadRaisedFee] = useState([]);

    //TOKEN_W86_FEE_OPTION_1
    const [tokeW86FeeOption1, setTokeW86FeeOption1] = useState([]);

    //TOKEN_W86_FEE_OPTION_2
    const [tokeW86FeeOption2, setTokeW86FeeOption2] = useState([]);

    const [createTokenForm] = Form.useForm();
    const w3 = window.ethereum ? new web3(window.ethereum) : new web3(provider);
    const [tokenApprove, setTokenApprove] = useState(0);
    const [amountRaisedFee, setAmountRaisedFee] = useState([]);
    const [initTokenFee, setInitTokenFee] = useState(0);
    const [checkUpdate, setCheckUpdate] = useState(false);
    const [standardFeeWallet, setStandardFeeWallet] = useState("");
    const [lpFeeWallet, setLpFeeWallet] = useState("");



    const getChainNetworkList = async () => {
        const dataFilter = { page: 0, size: 10, sort: 'id,desc', vm: 'EVM' };
        try {
            let res = await IdoLaunchpad.getChainNetworkList(dataFilter);
            if (res.status === 200) {
                if (res.data.length > 0) {
                    setChainNetworkList(res.data);
                }
            }
        } catch (error) {
            console.log('Error: ', error);
        } finally {
            // setLoading(false);
        }
    };
    const getSettings = async () => {

        try {
            let res = await IdoLaunchpad.getSettingsByChain(chainId);
            if (res.status === 200) {
                if (res.data.length > 0) {
                    let initFee = res.data.filter((itemSetting) => INIT_TOKEN_FEE === itemSetting.settingKey);
                    if (initFee.length > 0) {
                        setInitTokenFee(parseFloat(initFee[0].settingValue))
                    }

                    let standardWallet = res.data.filter((itemSetting) => INIT_TOKEN_FEE_WALLET === itemSetting.settingKey);
                    if (standardWallet.length > 0) {
                        setStandardFeeWallet(standardWallet[0].settingValue)
                    }

                    let lpWallet = res.data.filter((itemSetting) => INIT_LIQUIDITY_TOKEN_FEE_WALLET === itemSetting.settingKey);
                    if (lpWallet.length > 0) {
                        setLpFeeWallet(lpWallet[0].settingValue)
                    }

                    setFeeList(res.data);
                    let poolFee = res.data.filter((itemSetting) => INIT_LAUNCHPAD_FEE === itemSetting.settingKey);

                    let launchpadRaisedFeeOnlyObj = res.data.filter((itemSetting) => LIST_LAUNCHPAD_RAISED_FEE_ONLY === itemSetting.settingKey);

                    let launchpadTokenRaisedFeeObj = res.data.filter((itemSetting) => LIST_LAUNCHPAD_TOKEN_RAISED_FEE === itemSetting.settingKey);

                    let launchpadRaisedFeeObj = res.data.filter((itemSetting) => LIST_LAUNCHPAD_RAISED_FEE === itemSetting.settingKey);

                    let tokeW86FeeOption1Obj = res.data.filter((itemSetting) => LIST_LAUNCHPAD_TOKEN_HLUP_FEE_OPTION_1 === itemSetting.settingKey);

                    let tokeW86FeeOption2Obj = res.data.filter((itemSetting) => LIST_LAUNCHPAD_TOKEN_HLUP_FEE_OPTION_2 === itemSetting.settingKey);

                    let amountRaised = res.data.filter((itemSetting) => LAUNCHPAD_AMOUNT_RAISED_FEE === itemSetting.settingKey);
                    if (poolFee[0]) {
                        setCreatePoolFee(poolFee[0]);
                    }
                    if (launchpadRaisedFeeOnlyObj && launchpadRaisedFeeOnlyObj[0]) {
                        setLaunchpadRaisedFeeOnly(launchpadRaisedFeeOnlyObj[0]);
                    }
                    if (launchpadTokenRaisedFeeObj && launchpadTokenRaisedFeeObj[0]) {
                        setLaunchpadTokenRaisedFee(launchpadTokenRaisedFeeObj[0]);
                    }
                    if (launchpadRaisedFeeObj && launchpadRaisedFeeObj[0]) {
                        setLaunchpadRaisedFee(launchpadRaisedFeeObj[0]);
                    }
                    if (tokeW86FeeOption1Obj && tokeW86FeeOption1Obj[0]) {
                        setTokeW86FeeOption1(tokeW86FeeOption1Obj[0]);
                    }
                    if (tokeW86FeeOption2Obj && tokeW86FeeOption2Obj[0]) {
                        setTokeW86FeeOption2(tokeW86FeeOption2Obj[0]);
                    }
                    if (amountRaised[0]) {
                        setAmountRaisedFee(amountRaised[0]);
                    }
                }
            }
        } catch (error) {
            console.log('Error: ', error);
        } finally {
            // setLoading(false);
        }
    };


    useEffect(() => {
        getChainNetworkList();
        if (chainId) {
            getSettings();
        }
    }, [account, chainId]);


    useEffect(() => {
        if (chainId) {
            
            const dexList = dexExchanges[chainId];
            setCexList(dexList);

            setBaseCurrencies(Object.keys(currencies[chainId]))
            if (tokenInfo && tokenInfo.currency_pay) {
                if (Object.keys(currencies[chainId][tokenInfo.currency_pay])) {
                    activeCurrencyPay = tokenInfo.currency_pay;
                } else {
                    activeCurrencyPay = Object.keys(currencies[chainId])[0];
                }
            } else {
                activeCurrencyPay = Object.keys(currencies[chainId])[0];
            }

            setCurrencyPay(activeCurrencyPay);

            // console.log('activeCurrencyPay------', activeCurrencyPay);

            form.setFieldsValue({
                currency_pay: activeCurrencyPay,
                currency_pay_address: getCurrencyAddress(chainId, activeCurrencyPay),
                currency_pay_decimals: getCurrencyDecimals(chainId, activeCurrencyPay)
            })

        } else {
            setCexList([])
        }
    }, [chainId])

    useEffect(() => {

        if (!checkUpdate && chainId) {
            if ((tokenInfo && tokenInfo.chainId == chainId) || tokenApproval) {
                form.setFieldsValue({
                    init_launchpad_fee: createPoolFee?.settingValue,
                    chainId: chainId,
                    token_network_chain: networkChain,
                    token_address: tokenInfo ? tokenInfo.token_address : tokenApproval?.token_address,
                    token_name: tokenInfo ? tokenInfo.token_name : tokenApproval?.token_name,
                    token_symbol: tokenInfo ? tokenInfo.token_symbol : tokenApproval?.token_symbol,
                    token_decimal: tokenInfo ? tokenInfo.token_decimal : tokenApproval?.token_decimal,
                    total_supply: tokenInfo ? tokenInfo.total_supply : tokenApproval?.total_supply,
                    currency_pay: tokenInfo ? tokenInfo.currency_pay : tokenApproval?.currency_pay || activeCurrencyPay,
                    currency_pay_address: tokenInfo ? tokenInfo.currency_pay_address : tokenApproval?.currency_pay_address || getCurrencyAddress(chainId, activeCurrencyPay),
                    currency_pay_decimals: tokenInfo ? tokenInfo.currency_pay_decimals : tokenApproval?.currency_pay_decimals || getCurrencyDecimals(chainId, activeCurrencyPay),
                    fee_options: tokenInfo ? tokenInfo.fee_options : tokenApproval?.fee_options || feeOptions,
                    listing_option: tokenInfo ? tokenInfo.listing_option : tokenApproval?.listing_option || listingOptions
                })
            } else {
                form.setFieldsValue({
                    init_launchpad_fee: createPoolFee?.settingValue,
                    chainId: chainId,
                    token_network_chain: networkChain,
                    token_address: '',
                    token_name: '',
                    token_symbol: '',
                    token_decimal: 18,
                    total_supply: 0,
                    currency_pay: activeCurrencyPay,
                    currency_pay_address: getCurrencyAddress(chainId, activeCurrencyPay),
                    currency_pay_decimals: getCurrencyDecimals(chainId, activeCurrencyPay),
                    fee_options: feeOptions,
                    listing_option: listingOptions
                });
            }

            setCheckUpdate(true);
        }
    }, [tokenInfo, account, chainId]);

    const onChangeTokenType = (value) => {
        setTokenType(value);
    };

    const onChangeTokenAddress = async (values) => {
        setErrorCallSC(false);
        const tokenAddressVal = values.target.value;

        setLoadingTokenInfo(true);
        setTokenAddress(tokenAddressVal);
        try {
            let allowance = await getTokenAllowance(tokenInfoAbi, tokenAddressVal, account, deployLaunchpadAddress)
            let [
                token_symbol,
                total_supply,
                token_name,
                token_decimal] = await Promise.all([

                    getSymbolToken(tokenInfoAbi, tokenAddressVal),
                    getTotalSupply(tokenInfoAbi, tokenAddressVal),
                    getTokenName(tokenInfoAbi, tokenAddressVal),
                    getTokenDecimal(tokenInfoAbi, tokenAddressVal)
                ]);

            setTokenApprove(parseInt(allowance));

            if (token_symbol && total_supply && token_name && token_decimal) {
                let tokenInfoNew = {
                    token_approval: parseInt(allowance) > 0 ? true : false,
                    token_address: tokenAddressVal,
                    token_name: token_name,
                    token_symbol: token_symbol,
                    token_decimal: token_decimal,
                    total_supply: parseFloat(ethers.utils.formatUnits(total_supply.toString(), token_decimal)),
                    currency_pay: form.getFieldValue('currency_pay'),
                    currency_pay_address: getCurrencyAddress(form.getFieldValue('currency_pay')),
                    currency_pay_decimals: getCurrencyDecimals(form.getFieldValue('currency_pay')),
                };
                window.localStorage.setItem('tokenApproval', JSON.stringify(tokenInfoNew));
                window.location.reload();

                window.localStorage.removeItem('tokenInfo');
                window.localStorage.removeItem('launchpadInfo');
                window.localStorage.removeItem('additionalInfo');
                setLoadingTokenInfo(false);

            } else {
                setTokenAddress(tokenAddressVal);
                window.localStorage.removeItem('tokenApproval');
                window.localStorage.removeItem('tokenInfo');
                window.localStorage.removeItem('launchpadInfo');
                window.localStorage.removeItem('additionalInfo');
                setLoadingTokenInfo(false);
                setErrorCallSC(true);
            }
        } catch (e) {
            console.log(e);
            setTokenAddress(tokenAddressVal);
            window.localStorage.removeItem('tokenApproval');
            window.localStorage.removeItem('tokenInfo');
            window.localStorage.removeItem('launchpadInfo');
            window.localStorage.removeItem('additionalInfo');
            setLoadingTokenInfo(false);
            setErrorCallSC(true);
        }
    };


    const createStandardTokenForm = async (values) => {
        try {
            setLoading(true);
            setLoadingTokenInfo(true);
            await createStandardToken(standardTokenAbi,
                `0x${STANDARD_TOKEN_BYTECODE}`,
                library,
                account,
                values.name,
                values.symbol,
                parseInt(values.decimals),
                ethers.utils.parseUnits(`${values.total_supply}`, values.decimals),
                standardFeeWallet,
                ethers.utils.parseUnits(`${initTokenFee}`, 'ether').toHexString()
            )
                .then((txn) => {
                    if (txn && txn.hash) {
                        let countNoti = 0;
                        const interval = setInterval(function () {
                            (async () => {
                                const res = await w3.eth.getTransactionReceipt(txn.hash);
                                if (res) {
                                    clearInterval(interval);
                                    if (res.status && res.blockNumber && res.contractAddress) {
                                        if (!countNoti) {
                                            countNoti++;
                                            setTokenAddress(res.contractAddress);
                                            Store.addNotification(addNotify('Create Standard Token Successfully!', 'success'));
                                            closeBox()

                                            const tokenInfo = {
                                                name: values.name,
                                                symbol: values.symbol,
                                                decimals: values.decimals,
                                                supply: values.total_supply
                                            };
                                            let tokenInfoApproval = {
                                                token_approval: false,
                                                token_address: res.contractAddress,
                                                token_name: values.name,
                                                token_symbol: values.symbol,
                                                token_decimal: parseInt(values.decimals),
                                                total_supply: values.total_supply,
                                            };

                                            window.localStorage.setItem(`${chainId}/${res.contractAddress.toLowerCase()}`, JSON.stringify(tokenInfo));
                                            window.localStorage.setItem('tokenApproval', JSON.stringify(tokenInfoApproval));
                                            window.location.reload();
                                        }
                                    } else {
                                        Store.addNotification(addNotify('Create Standard Token Failed!', 'danger'));
                                    }
                                    setLoading(false);
                                    setLoadingTokenInfo(false);
                                }
                            })();
                        }, 1000);
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    console.log(error);
                    setIsCreateTokenVisible(false);
                    setLoadingTokenInfo(false);
                    if (error) {
                        if (error.code == 4001 && error.message) {
                            Store.addNotification(addNotify(error.message, 'danger'));
                        } else if (error.reason) {
                            Store.addNotification(addNotify(error.reason, 'danger'));
                        } else {
                            if (error.data && error.data.message) {
                                Store.addNotification(addNotify(error.data.message, 'danger'));
                            }
                        }
                    }
                });

        } catch (e) {
            setLoading(false);
            setIsCreateTokenVisible(false);
            setLoadingTokenInfo(false);
            console.log(e);

            Store.addNotification(addNotify('Error!', 'danger'));
        }
    };

    const onSubmitCreateTokenForm = async (values) => {
        createStandardTokenForm(values)
    };


    const showCreateTokenModal = () => {
        createTokenForm.resetFields()
        setIsCreateTokenVisible(true);
    }

    const closeBox = () => {
        setIsCreateTokenVisible(false);
    };

    const onChangeCurrencyPay = e => {
        setCurrencyPay(e.target.value);

        let address = getCurrencyAddress(chainId, e.target.value)
        let decimals = getCurrencyDecimals(chainId, e.target.value)
        form.setFieldsValue({
            currency_pay_address: address,
            currency_pay_decimals: decimals
        })
    };
    const onChangeFee = e => {
        setFeeOptions(e.target.value);
    };
    const onChangeListing = e => {
        setListingOptions(e.target.value);
    };

    const handleApproveToken = async () => {
        let tokenAddressVal = form.getFieldValue('token_address');
        try {
            if (!tokenAddressVal) {
                return;
            }
            // const tokenContract  = useTokenInfoContract(tokenInfo?.token_address);
            setLoadingFull(true);
            await approveToken(tokenInfoAbi, tokenAddressVal, library, account, deployLaunchpadAddress)
                .then((txn) => {
                    if (txn && txn.hash) {
                        let countNoti = 0;
                        const interval = setInterval(function () {
                            (async () => {
                                const res = await w3.eth.getTransactionReceipt(txn.hash);
                                if (res) {
                                    clearInterval(interval);
                                    if (res.status && res.blockNumber) {
                                        !countNoti && Store.addNotification(addNotify('Approve Successfully', 'success'));
                                        countNoti++;
                                        setTokenApprove(Math.pow(2, 256));
                                        if (tokenApproval) {
                                            let tokenInfoNew = {
                                                token_approval: true,
                                                currency_pay: form.getFieldValue('currency_pay'),
                                                currency_pay_address: getCurrencyAddress(chainId, form.getFieldValue('currency_pay')),
                                                currency_pay_decimals: getCurrencyDecimals(chainId, form.getFieldValue('currency_pay')),
                                                fee_options: feeOptions,
                                                listing_option: listingOptions,
                                                token_address: tokenApproval?.token_address,
                                                token_name: tokenApproval?.token_name,
                                                token_symbol: tokenApproval?.token_symbol,
                                                token_decimal: tokenApproval?.token_decimal,
                                                total_supply: tokenApproval?.total_supply,
                                            };
                                            window.localStorage.setItem('tokenApproval', JSON.stringify(tokenInfoNew));
                                            window.location.reload();
                                        }
                                    } else {
                               
                                        Store.addNotification(addNotify('Approve Failed', 'danger'))
                                    }
                                    setLoadingFull(false);
                                }
                            })();
                        }, 1000);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    setLoadingFull(false);
                    if (error) {
                        if (error.code == 4001 && error.message) {
                            Store.addNotification(addNotify(error.message, 'danger'));
                        } else if (error.reason) {
                            Store.addNotification(addNotify(error.reason, 'danger'));
                        } else {
                            if (error.data && error.data.message) {
                                Store.addNotification(addNotify(error.data.message, 'danger'));
                            }
                        }
                    }
                });
        } catch (error) {
            setLoadingFull(false);
            console.log(error);
        }
    };
    let createPoolFeeDisOP1 = 0;
    let launchpadRaisedFeeOnlyDisOP1 = 0;
    if (createPoolFee && launchpadRaisedFeeOnly && tokeW86FeeOption1) {
        createPoolFeeDisOP1 = createPoolFee.settingValue - (createPoolFee.settingValue * (tokeW86FeeOption1.settingValue / 100));
        launchpadRaisedFeeOnlyDisOP1 = launchpadRaisedFeeOnly.settingValue - (launchpadRaisedFeeOnly.settingValue * (tokeW86FeeOption1.settingValue / 100));
    }
    let createPoolFeeOP2 = 0;
    let launchpadTokenRaisedFeeOP2 = 0;
    let launchpadRaisedFeeOP2 = 0;
    if (createPoolFee && launchpadTokenRaisedFee && launchpadRaisedFee && tokeW86FeeOption2) {
        createPoolFeeOP2 = createPoolFee.settingValue - (createPoolFee.settingValue * (tokeW86FeeOption2.settingValue / 100));
        launchpadTokenRaisedFeeOP2 = launchpadTokenRaisedFee.settingValue - (launchpadTokenRaisedFee.settingValue * (tokeW86FeeOption2.settingValue / 100));
        launchpadRaisedFeeOP2 = launchpadRaisedFee.settingValue - (launchpadRaisedFee.settingValue * (tokeW86FeeOption2.settingValue / 100));
    }

    return (
        <>
            
            <div className="sub-title-steps d-flex d-flex-btw text-25">
                <span className='text-darkblue text-weight-500'>Token Information</span>
                <button type="button" className="btn-basic w-fitcontent" disabled={networkChain.length > 0 && account ? false : true} onClick={showCreateTokenModal}>Create Token</button>
            </div>
            <div className="inputs-steps">
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" xs={24} xl={24} md={24} sm={24}>
                        <Form.Item name="step_verify_token" initialValue={1} hidden={true}>
                            <Input className="amount-buy" />
                        </Form.Item>
                        <Form.Item name="init_launchpad_fee" hidden={true}>
                            <Input className="amount-buy" />
                        </Form.Item>
                        <Form.Item name="chainId" hidden={true}>
                            <Input className="amount-buy" />
                        </Form.Item>
                        <Form.Item name="token_network_chain" hidden={true}>
                            <Input className="amount-buy" />
                        </Form.Item>
                        <Form.Item name="token_name" hidden={true}>
                            <Input className="amount-buy" />
                        </Form.Item>
                        <Form.Item name="token_symbol" hidden={true}>
                            <Input className="amount-buy" />
                        </Form.Item>
                        <Form.Item name="token_decimal" hidden={true}>
                            <Input className="amount-buy" />
                        </Form.Item>
                        <Form.Item name="total_supply" hidden={true}>
                            <Input className="amount-buy" />
                        </Form.Item>
                        <Form.Item name="currency_pay_decimals" hidden={true}>
                            <Input className="amount-buy" />
                        </Form.Item>
                        <Form.Item name="currency_pay_address" hidden={true}>
                            <Input className="amount-buy" />
                        </Form.Item>
                        <Form.Item
                            label="Token Address"
                            name="token_address"
                            rules={[{ required: true, message: 'Ex: 0x3C39f28e368420e3dEE3838E8b1de7422EA633E4' }]}
                            help={<><span className="warning-form blue-text mt-5 mb-5">Create token fee: {initTokenFee} {createPoolFee?.payToken}</span></>}
                        >
                            <Input disabled={account ? false : true} className="amount-buy" placeholder="Ex: 0x3C39f28e368420e3dEE3838E8b1de7422EA633E4" onBlur={onChangeTokenAddress} />

                        </Form.Item>
                        {!errorCallSC ? (
                            loadingTokenInfo ? (
                                <div className="loading-info">
                                    <Space size="middle">
                                        <Spin size="large" />
                                    </Space>
                                </div>
                            ) : (
                                tokenApproval?.token_address && tokenApproval?.token_symbol && tokenApproval?.token_decimal && (
                                    <>
                                        <div className="token-info-anti mt-15 mb-15">
                                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="token-info-row">
                                                <Col className="gutter-row" xs={12} xl={12} md={12} sm={12}>
                                                    <div className="token-name">Name</div>
                                                </Col>
                                                <Col className="gutter-row" xs={12} xl={12} md={12} sm={12}>
                                                    <div className="token-value">{tokenApproval?.token_name}</div>
                                                </Col>
                                            </Row>
                                        
                                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="token-info-row">
                                                <Col className="gutter-row" xs={12} xl={12} md={12} sm={12}>
                                                    <div className="token-name">Symbol</div>
                                                </Col>
                                                <Col className="gutter-row" xs={12} xl={12} md={12} sm={12}>
                                                    <div className="token-value">{tokenApproval?.token_symbol}</div>
                                                </Col>
                                            </Row>
                                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="token-info-row">
                                                <Col className="gutter-row" xs={12} xl={12} md={12} sm={12}>
                                                    <div className="token-name">Decimals</div>
                                                </Col>
                                                <Col className="gutter-row" xs={12} xl={12} md={12} sm={12}>
                                                    <div className="token-value">{tokenApproval?.token_decimal}</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </>
                                )
                            )

                        ) : (
                            <>
                                <Alert style={{ marginTop: '10px', marginBottom: '10px' }} message="Token not found." type="error" showIcon />
                            </>
                        )}
                    </Col>
                    <Col className="gutter-row" xs={24} xl={24} md={24} sm={24}>
                        <Form.Item
                            name="currency_pay"
                            label="Currency Pay"
                            initialValue={activeCurrencyPay}
                            rules={[{ required: true, message: 'Please pick Currency Pay!' }]}
                        >

                            <Radio.Group style={{ width: '80%' }} onChange={onChangeCurrencyPay}>
                                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                    {baseCurrencies.map((item, index) => {

                                        return(
                                            <Col key={'currencies' + index} className='gutter-row' xs={24} xl={4} md={4} sm={4}>
                                                <Radio value={item}>{item}</Radio>
                                            </Col>
                                        )
                                    })}
                                </Row>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" xs={24} xl={24} md={24} sm={24}>
                        <Form.Item
                            name="fee_options"
                            label="Fee Options"
                            initialValue={feeOptions}
                            rules={[{ required: true, message: 'Please pick fee options!' }]}
                        >
                            <Radio.Group onChange={onChangeFee}>
                                <Space direction="vertical">
                                    {createPoolFee && launchpadRaisedFeeOnly && (
                                        <Radio value={JSON.stringify([INIT_LAUNCHPAD_FEE, LIST_LAUNCHPAD_RAISED_FEE_ONLY])} key={'fee-1'}>
                                            {createPoolFee.settingValue} {createPoolFee.feeType == "PERCENT" ? '%' : createPoolFee.payToken} + {" "}
                                            {launchpadRaisedFeeOnly.settingValue}{launchpadRaisedFeeOnly.feeType == "PERCENT" ? '%' : ''} {form.getFieldValue('currency_pay')} Sold
                                        </Radio>
                                    )}
                                    {createPoolFee && launchpadTokenRaisedFee && launchpadRaisedFee && (
                                        <Radio value={JSON.stringify([INIT_LAUNCHPAD_FEE, LIST_LAUNCHPAD_TOKEN_RAISED_FEE, LIST_LAUNCHPAD_RAISED_FEE])} key={'fee-2'}>
                                            {createPoolFee.settingValue} {createPoolFee.feeType == "PERCENT" ? '%' : createPoolFee.payToken} + {" "}
                                            {launchpadTokenRaisedFee.settingValue}{launchpadTokenRaisedFee.feeType == "PERCENT" ? '%' : ''} of Tokens Sold + {" "}
                                            {launchpadRaisedFee.settingValue}{launchpadRaisedFee.feeType == "PERCENT" ? '%' : ''} of {form.getFieldValue('currency_pay')} Sold
                                        </Radio>
                                    )}

                                    {/* option 1 */}
                                    {createPoolFee && launchpadRaisedFeeOnly && tokeW86FeeOption1 && createPoolFeeDisOP1 > 0 && launchpadRaisedFeeOnlyDisOP1 > 0 && (
                                        <>
                                            <Radio disabled={true} value={JSON.stringify([INIT_LAUNCHPAD_FEE, LIST_LAUNCHPAD_RAISED_FEE_ONLY, LIST_LAUNCHPAD_TOKEN_HLUP_FEE_OPTION_1])} key={'fee-3'}>
                                                Amount of HLUP equivalent to {createPoolFeeDisOP1 ? new Intl.NumberFormat("ja-JP").format(createPoolFeeDisOP1) : 0} {createPoolFee.feeType == "PERCENT" ? '%' : createPoolFee.payToken} +
                                                {launchpadRaisedFeeOnlyDisOP1}{launchpadRaisedFeeOnly.feeType == "PERCENT" ? '%' : ''} {form.getFieldValue('currency_pay')} Sold <span className='text-danger'>({tokeW86FeeOption1.settingValue}% discount of option 1) </span> <small className='text-info'>(Coming soon)</small>
                                            </Radio>
                                        </>
                                    )}

                                    {/* option 1 */}
                                    {createPoolFee && launchpadTokenRaisedFee && launchpadRaisedFee && tokeW86FeeOption2 && createPoolFeeOP2 > 0 && launchpadTokenRaisedFeeOP2 > 0 && launchpadRaisedFeeOP2 > 0 && (
                                        <>
                                            <Radio disabled={true} value={JSON.stringify([INIT_LAUNCHPAD_FEE, LIST_LAUNCHPAD_TOKEN_RAISED_FEE, LIST_LAUNCHPAD_RAISED_FEE, LIST_LAUNCHPAD_TOKEN_HLUP_FEE_OPTION_2])} key={'fee-4'}>
                                                Amount of HLUP equivalent to {createPoolFeeOP2} {createPoolFee.feeType == "PERCENT" ? '%' : createPoolFee.payToken} +
                                                {launchpadTokenRaisedFeeOP2}{launchpadTokenRaisedFee.feeType == "PERCENT" ? '%' : ''} of Tokens Sold +
                                                {launchpadRaisedFeeOP2}{launchpadRaisedFee.feeType == "PERCENT" ? '%' : ''} of {form.getFieldValue('currency_pay')} Sold <span className='text-danger'>({tokeW86FeeOption2.settingValue}% discount of option 2) </span> <small className='text-info'>(Coming soon)</small>
                                            </Radio>
                                        </>
                                    )}

                                </Space>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" xs={24} xl={24} md={24} sm={24}>
                        <Form.Item
                            name="listing_option"
                            label="Listing Options"
                            rules={[{ required: true, message: 'Please pick listing options!' }]}
                        >
                            <Radio.Group onChange={onChangeListing}>
                                <Space direction="vertical">
                                    <Radio value={1} key={'listing-2'}>Manual Listing</Radio>
                                    {chainId == 8668 && (
                                        <Radio value={0} key={'listing-1'}>Auto Listing</Radio>
                                    )}
                                    
                                </Space>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" xs={24} xl={24} md={24} sm={24}>
                        {listingOptions == 0 ? (
                            <Alert className="mb-15" message="For auto listing, after you finalize the pool your token will be auto listed on DEX." showIcon type="warning" />
                        ) : (
                            <>
                                <Alert className="mb-15" message={`For manual listing, UpSwap won't charge tokens for liquidity.
                            You may withdraw ${currencyPay ? currencyPay : baseCurrencies[0]} after the pool ends then do DEX listing yourself.`} showIcon type="warning" />
                            </>
                        )}
                        <Alert className="mb-15" message="Make sure the token has 'Exclude transfer fee' function if it has transfer fees." showIcon type="warning" />
                    </Col>
                </Row>

                {tokenApproval?.token_address && tokenApproval?.token_symbol && tokenApproval?.token_decimal && (
                    <>
                        {!tokenApproval?.token_approval && (
                            <div className="steps-action">
                                <button type='button' onClick={handleApproveToken} className="btn-basic w-fitcontent">Click to Approval {loadingFull && (<Spin />)}</button>
                            </div>
                        )}
                    </>
                )}

            </div>

            <Modal
                title={<div className="text-md custom-modal-title">Create Token</div>}
                visible={isCreateTokenVisible}
                className="custom-modal create-token-modal"
                footer={false}
            >
                <div className="transer-box-content">
                    <Form
                        form={createTokenForm}
                        name="basic"
                        initialValues={{ price: 0 }}
                        autoComplete="off"
                        onFinish={onSubmitCreateTokenForm}
                        layout="vertical"
                        className='basic-form'
                    >
                        <Form.Item name="token_type" label="Token type" initialValue={tokenType}
                            rules={[{ required: true, message: 'Please input round type!' }]}
                            help={<><span className="warning-form blue-text">Create fee: {initTokenFee} {createPoolFee?.payToken}</span></>}
                        >
                            <Select className="select-create-ido" onChange={onChangeTokenType}>
                                {/*<Option value="">Select token type</Option>*/}
                                <Option value="standard">Standard Token</Option>
                                {/* <Option value="liquidity">Liquidity Generator Token</Option> */}
                                {/*<Option value="baby">Baby Token</Option>*/}
                                {/*<Option value="buyback">Buyback Baby Token</Option>*/}
                            </Select>
                        </Form.Item>
                        <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Please input token name!' }]}>
                            <Input className="amount-buy" placeholder="Ex: Ethereum" />
                        </Form.Item>
                        <Form.Item name="symbol" label="Ticker" rules={[{ required: true, message: 'Please input token Ticker!' }]}>
                            <Input className="amount-buy" placeholder="Ex: ETH" />
                        </Form.Item>
                        
                        <Form.Item name="decimals" label="Decimals" rules={[{ required: true, message: 'Please input Decimals!' }]}>
                            <Input type="number" className="amount-buy" placeholder="Ex: 18" />
                        </Form.Item>
                        
                        <Form.Item name="total_supply" label="Total supply" rules={[{ required: true, message: 'Please input Total supply!' }]}>
                            <Input type="number" className="amount-buy" placeholder="Ex: 1000000" />
                        </Form.Item>

                       
                        <div className="d-flex">
                            <button className="btn-basic" disabled={loading} type="submit">Create Token {loading && <Spin size="small" />}</button>
                            <button className="btn-basic-default" disabled={loading} onClick={closeBox}>Close</button>
                        </div>
                    </Form>

                </div>
            </Modal>
            {loadingFull && (
                <Loader />
            )}
        </>
    )
}

export default VerifyToken
